@if (isVisible()) {
  <div role="status" aria-live="polite" [class]="overlayClass()">
    <svg
      viewBox="0 0 140 76"
      [class]="svgClass()"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g class="motion-reduce:hidden">
        <line
          x1="4"
          y1="24"
          x2="16"
          y2="24"
          stroke="hsl(var(--k-color-accent))"
          stroke-width="3"
          stroke-linecap="round"
          class="animate-pulse"
        />
        <line
          x1="2"
          y1="36"
          x2="18"
          y2="36"
          stroke="hsl(var(--k-color-accent))"
          stroke-width="3"
          stroke-linecap="round"
          class="animate-pulse [animation-delay:150ms]"
        />
        <line
          x1="5"
          y1="48"
          x2="15"
          y2="48"
          stroke="hsl(var(--k-color-accent))"
          stroke-width="3"
          stroke-linecap="round"
          class="animate-pulse [animation-delay:300ms]"
        />
      </g>

      <rect x="26" y="16" width="54" height="36" rx="5" fill="hsl(var(--k-color-primary))" />
      <path d="M80 28h14l16 14v10H80z" fill="hsl(var(--k-color-primary))" fill-opacity="0.75" />
      <path d="M94 31h8l9 8h-17z" fill="hsl(var(--k-color-card))" fill-opacity="0.9" />

      <line
        x1="36"
        y1="28"
        x2="60"
        y2="28"
        stroke="hsl(var(--k-color-primary-foreground))"
        stroke-opacity="0.5"
        stroke-width="3"
        stroke-linecap="round"
      />
      <line
        x1="36"
        y1="38"
        x2="52"
        y2="38"
        stroke="hsl(var(--k-color-primary-foreground))"
        stroke-opacity="0.5"
        stroke-width="3"
        stroke-linecap="round"
      />

      <g class="origin-center animate-spin [transform-box:fill-box] motion-reduce:animate-none">
        <circle cx="46" cy="58" r="9" fill="hsl(var(--k-color-foreground))" />
        <circle cx="46" cy="58" r="3.5" fill="hsl(var(--k-color-card))" />
        <line
          x1="46"
          y1="51"
          x2="46"
          y2="65"
          stroke="hsl(var(--k-color-card))"
          stroke-width="1.5"
        />
      </g>

      <g class="origin-center animate-spin [transform-box:fill-box] motion-reduce:animate-none">
        <circle cx="100" cy="58" r="9" fill="hsl(var(--k-color-foreground))" />
        <circle cx="100" cy="58" r="3.5" fill="hsl(var(--k-color-card))" />
        <line
          x1="100"
          y1="51"
          x2="100"
          y2="65"
          stroke="hsl(var(--k-color-card))"
          stroke-width="1.5"
        />
      </g>

      <line
        x1="6"
        y1="71"
        x2="134"
        y2="71"
        stroke="hsl(var(--k-color-border))"
        stroke-width="3"
        stroke-linecap="round"
      />
    </svg>

    <p class="text-sm font-medium text-foreground">
      {{ displayMessage() ?? 'Cargando…' }}
    </p>
  </div>
}
